

export function  errorHandler(error) {
    console.log(error);
}

export function noEmpty(field) {
    return (field != undefined) && (field != null) && (field != '') && (field != -1);
}

export const  diagonalbackURL = (process.env.NODE_ENV == "development") ? "http://192.168.0.16:5555/AdminWs" : "/AdminWs";
// Pour Daniel
//export const  diagonalbackURL = "https://portail-ws.prolexis.com/AdminWs";

export const defaultConfig = {
    headers:{
        'Content-Type':'application/json;charset=utf-8',
        'Accept':'application/json'
    }
}

export const URLEncodedConfig = {
    headers:{
        'Content-Type':'application/x-www-form-urlencoded',
    }
}

export const OctetStreamConfig = {
    responseType: 'blob',
    headers:{
        'Content-Type': 'application/octet-stream',
        'accept':'application/octet-stream',
        
    }
}

export const FormDataConfig = {
    responseType: 'blob',
    headers:{
        'Content-Type': 'multipart/form-data'   
    }
}


console.log("Test NODE_ENV : " + process.env.NODE_ENV)

